import React from 'react';
import { useStoreMap } from 'effector-react';
import { $tourData } from '@stores/dataStores';
import Checkbox from '@components/Checkbox';
import { isSTMap } from '@modules/sandTable/utils/sandTableTypeCheck';

interface Props {
  id: string;
  isSelected?: boolean;
  onClick: (id: string) => void;
}

export const BatchModeItem = React.memo(
  ({ id, isSelected, onClick }: Props) => {
    const data = useStoreMap({
      store: $tourData,
      keys: [id],
      fn: (state) => state.sandBox?.find((item) => item.id === id),
    });

    if (!data) return null;
    const getText = () => (isSTMap(data) ? '地图' : '图片');

    return (
      <div
        className="mb-10 flex h-35 w-full cursor-pointer select-none items-center rounded bg-black-#28 px-10 hover:bg-black-#34"
        onClick={() => onClick(id)}
      >
        <Checkbox
          className="flex-shrink-0"
          checked={isSelected}
          onClick={() => onClick(id)}
        />
        <div className="mx-10 truncate text-base text-white">{data.name}</div>
        <div className="ml-auto flex-shrink-0 text-sm text-black-gray">
          {getText()}
        </div>
      </div>
    );
  }
);
